module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emai-register-wrapper"
  }, [_c('div', {
    staticClass: "stepOneRegister"
  }, [_c('div', {
    staticClass: "account-form"
  }, [_c('div', {
    staticClass: "form-row email-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email",
      "name": "userName",
      "placeholder": _vm.$t('register.email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t(_vm.emailError)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "type": "text",
      "name": "code",
      "placeholder": _vm.$t('register.code')
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "send-code-btn",
    attrs: {
      "src": _vm.randomCode,
      "alt": ""
    },
    on: {
      "click": _vm.updateCode
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t(_vm.codeError)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('register.password_set')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.save($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t(_vm.passwordError)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('country-com', {
    attrs: {
      "lang": _vm.lang
    },
    model: {
      value: (_vm.countryInfo),
      callback: function($$v) {
        _vm.countryInfo = $$v
      },
      expression: "countryInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "checkbox-wapper"
  }, [_c('span', {
    staticClass: "checkbox",
    on: {
      "click": _vm.alocked
    }
  }, [(!_vm.checked) ? _c('i', {
    staticClass: "icon-box iconfont"
  }) : _c('i', {
    staticClass: "icon-checked iconfont"
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#cccccc"
    }
  }, [_vm._v(_vm._s(_vm.$t('register.protocol_a'))), _c('span', {
    staticClass: "checkbox-text",
    staticStyle: {
      "color": "#272f44"
    },
    on: {
      "click": _vm.registerService
    }
  }, [_vm._v(_vm._s(_vm.$t('register.protocol_b')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('button', {
    class: {
      'save-phone-btn': _vm.checked, 'no-save-phone-btn': !_vm.checked
    },
    attrs: {
      "disabled": !_vm.checked
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('register.submit')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row login"
  }, [_c('p', [_c('span', {
    staticClass: "login-btn",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('register.login_now')) + " "), _c('span', {
    staticClass: "iconfont icon-login-right"
  })])])])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "appear": _vm.processing
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7185af66", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7185af66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailRegister/emailRegister.vue
// module id = 433
// module chunks = 3